import { createSlice } from "@reduxjs/toolkit";
import { fetchSupplierStockOverview } from "./thunk";

interface DistrictState {
  supplierStockOverviewList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  supplierStockOverviewList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const inventorySupplierStockOverviewSlice = createSlice({
  name: "stockOverviewReducer",
  initialState,
  reducers: {
    clearSupplierStockOverview: (state) => {
      state.supplierStockOverviewList = [];
      state.rowCount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierStockOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupplierStockOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.supplierStockOverviewList = action.payload.data;
        state.rowCount = action.payload.rowCount;
        console.log("action.payload", action.payload);
      })
      .addCase(fetchSupplierStockOverview.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch fetchStockOverview";
      });
  },
});

export const { clearSupplierStockOverview } =
  inventorySupplierStockOverviewSlice.actions;
export default inventorySupplierStockOverviewSlice.reducer;
